import APP_SERVERS from '../resources/js/servers';

import LEADS_IGM from '../resources/imgs/apps/leads.jpg';
import CONSTRUCTION_IMG from '../resources/imgs/apps/construction.jpg';
import FINANCE_IMG from '../resources/imgs/apps/finance.png';

import CONTACTS_IMG from '../resources/imgs/apps/contacts.jpg';
import LOANS_IMG from '../resources/imgs/apps/loans.jpg';
import PHONE_SEARCH_IMG from '../resources/imgs/apps/phone_search.jpg';
import TEXTING_IMG from '../resources/imgs/apps/texting.png';
import REPORTING_IMG from '../resources/imgs/apps/reporting.png';
import DOCS_TEMPLATES_IMG from '../resources/imgs/apps/docs-templates.jpg';
import REO_IMG from '../resources/imgs/apps/reo.png';
import SERVICING_IMG from '../resources/imgs/apps/servicing.jpg';

export default {
  data: () => ({
    items: {
      top: [
        {
          label: 'Loans',
          link: APP_SERVERS.LOANS,
          src: LOANS_IMG,
          permission: 'loans:view_app',
        },
        {
          label: 'Contacts',
          link: APP_SERVERS.CONTACTS,
          src: CONTACTS_IMG,
          permission: 'contacts:view_app',
        },
        {
          label: 'Reporting',
          link: APP_SERVERS.REPORTING,
          src: REPORTING_IMG,
          permission: 'loans:view_app',
        },
        {
          label: 'Finance',
          link: APP_SERVERS.FINANCES,
          src: FINANCE_IMG,
          permission: 'finance:view_app',
        },
        {
          label: 'Phone Search',
          link: APP_SERVERS.PHONE_SEARCH,
          src: PHONE_SEARCH_IMG,
          permission: 'anchor_phonesearch:view_app',
        },
      ],
      middle: [
        {
          label: 'Texting',
          link: APP_SERVERS.TEXTING,
          src: TEXTING_IMG,
          permission: 'anchor_twilio:view_app',
        },
        {
          label: 'Leads',
          link: APP_SERVERS.LEADS,
          src: LEADS_IGM,
          permission: 'leads:view_app',
        },
        {
          label: 'Construction',
          link: APP_SERVERS.CONSTRUCTION,
          src: CONSTRUCTION_IMG,
          permission: 'construction:view_app',
        },
        {
          label: 'Docs Templates',
          link: APP_SERVERS.DOCS_TEMPLATES,
          src: DOCS_TEMPLATES_IMG,
          permission: 'docs:read',
        },
        {
          label: 'REO',
          link: APP_SERVERS.REO,
          src: REO_IMG,
          permission: 'reo:view_app',
        },
      ],
      bottom: [
        {
          label: 'Servicing',
          link: APP_SERVERS.SERVICING,
          src: SERVICING_IMG,
          permission: 'servicing:view_app',
        },
      ],
    },
  }),
};
